import { LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { IOsaExecucaoCustoRecursoModel } from '../models/osa-execucao-custo-recurso.model';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OsaExecucaoCustoRecursoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public async obterPorExecucao(osaExecucaoId: number, secaoId?: number): Promise<IBaseModel<IOsaExecucaoCustoRecursoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoCustoRecursoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoCustoRecurso/${osaExecucaoId}/secao/${secaoId}`)
      .toPromise();
  }

  public obterPorId(id: number): Observable<IBaseModel<IOsaExecucaoCustoRecursoModel>> {
    return this.httpClient.get<IBaseModel<IOsaExecucaoCustoRecursoModel>>(`${this.apiBaseUrl}/${id}`);
  }

  public inserir(data: IOsaExecucaoCustoRecursoModel): Observable<IBaseModel<IOsaExecucaoCustoRecursoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoCustoRecursoModel>>(`${this.apiBaseUrl}/OsaExecucaoCustoRecurso`, data);
  }

  public atualizar(data: IOsaExecucaoCustoRecursoModel): Observable<IBaseModel<IOsaExecucaoCustoRecursoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoCustoRecursoModel>>(`${this.apiBaseUrl}/OsaExecucaoCustoRecurso/${data.id}`, data)
  }

  public excluir(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoCustoRecurso/${id}`)
  }
}